// removed by extract-text-webpack-plugin
module.exports = {"errorpage":"ErrorPage_errorpage__37HU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/ErrorPage/ErrorPage.scss
// module id = 688
// module chunks = 0